// Copyright (c) Martin Costello, 2017. All rights reserved.
// Licensed under the Apache 2.0 license. See the LICENSE file in the project root for full license information.

export class Banner {
    public static show() {
        console.log('%cDownload the London Travel Alexa skill from Amazon: https://www.amazon.co.uk/dp/B01NB0T86R', 'color: #2c3e50;');
    }
}
